import retrieveDropdownAgents from 'app/shared/dropdown/sagas/retrieveDropdownAgents';
import retrieveDropdownOrgs from 'app/shared/dropdown/sagas/retrieveDropdownOrgs';

const sagaRegistry = [retrieveDropdownAgents, retrieveDropdownOrgs];

export default sagaRegistry;
